module.exports = __webpack_public_path__ + "acdf197a05336d8cdb11d03dd120d7e2.svg";